import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=2928fc37&scoped=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AppSkeleton.vue?vue&type=style&index=0&id=2928fc37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928fc37",
  null
  
)

export default component.exports